import { useUser } from "components/clerk";
import { BellIcon, Box, Button, HStack, Icon, Image, Link, MenuIcon, Text } from "components/ui";
import NotificationBadge from "components/ui/NotificationBadge";
import { ShoppingCart, UsersRound } from "lucide-react-native";
import React from "react";
import { Pressable } from "react-native";
import { useGetCartCurrentQuery, useGetNotificationQuery } from "store/abcoApi";
import { useGetPageTitle } from "utils/hooks/useGetPageTitle";
import { useIsAdminSection, useSiteRegion } from "utils/hooks/useSiteSection";
import SearchBar from "./SearchBar";
import { useSlideNavigation } from "./SlideNavigation";

type MobileHeaderProps = {};

export default function MobileHeader(props: MobileHeaderProps) {
	const isAdmin = useIsAdminSection();
	const { data: cart } = useGetCartCurrentQuery();
	const pageTitle = useGetPageTitle();

	const { open: openMobileMenu } = useSlideNavigation("mobileMenu");
	const { open: openCart } = useSlideNavigation("cart");
	const { isSignedIn } = useUser();
	const [showMobileOverlay, setShowMobileOverlay] = React.useState(true);
	const region = useSiteRegion();

	const {
		data: notificationData,
		isLoading,
		isFetching,
		isError,
		error,
		currentData,
	} = useGetNotificationQuery(
		{
			pageSize: 1,
			pageNumber: 1,
			hasRead: false,
		},
		{
			skip: !isSignedIn,
		},
	);

	return (
		<Box
			width="$full"
			sx={{
				"@md": { display: "none" },
			}}
		>
			{!isSignedIn && (
				<Box backgroundColor="$neutral25" paddingHorizontal={8} paddingVertical={region === "au" ? 16 : 12}>
					<HStack justifyContent="space-between" alignItems="center">
						<Pressable onPress={openMobileMenu}>
							<Icon color="$primary" as={MenuIcon} m="$2" size="md" />
						</Pressable>
						{region === "au" && <Image resizeMode="contain" source={require("assets/abco-logo.png")} style={{ width: 141, height: 35 }} alt="Abco: The Power to Clean 5" />}
						{region === "nz" && <Image resizeMode="contain" source={require("assets/logo-nz-new.svg")} alt="Abco: The Power to Clean 6" style={{ width: 250, height: 55 }} />}

						<Link href="/cart">
							<Box borderRadius={12} p="$3.5" alignItems="center" justifyContent="center" backgroundColor="$primarylight">
								<Icon as={ShoppingCart} color="$basicwhite " />
								{cart != null && cart.lines != null && cart.lines.length > 0 && (
									<Box position="absolute" top={-8} right={-8}>
										<NotificationBadge notificationCount={cart?.lines.length} notificationColor="danger" />
									</Box>
								)}
							</Box>
						</Link>
					</HStack>
				</Box>
			)}

			<Box backgroundColor="$primary" paddingHorizontal={16} paddingVertical={18}>
				<HStack space="xl" alignItems="center" mx="$0.5">
					{isSignedIn && (
						<>
							<Pressable onPress={openMobileMenu}>
								<Icon color="$basicwhite" as={MenuIcon} m="$2" size="md" />
							</Pressable>
						</>
					)}
					{isAdmin && (
						<Text flex={1} color="$basicwhite" fontSize={20}>
							{pageTitle}
						</Text>
					)}
					{!isAdmin && <SearchBar showMobileOverlay={showMobileOverlay} />}
					{isSignedIn && (
						<>
							{showMobileOverlay && (
								<Link href="/notifications">
									<Box borderRadius={12} position="relative" p="$3.5" alignItems="center" justifyContent="center" backgroundColor="$primarylight">
										<Icon as={BellIcon} color="$basicwhite " />
										<Box position="absolute" top={-8} right={-8}>
											{notificationData && <NotificationBadge notificationCount={notificationData.metaData.totalItemCount} notificationColor="danger" />}
										</Box>
									</Box>
								</Link>
							)}
							{!showMobileOverlay && (
								<Button borderRadius={12} position="relative" p="$3.5" alignItems="center" justifyContent="center" backgroundColor="$primarylight">
									<Icon as={UsersRound} color="$basicwhite " />
								</Button>
							)}
						</>
					)}
				</HStack>
			</Box>
		</Box>
	);
}
